import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DeviceWebSocketService } from './features/bots/device.websocket.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('gavoom');
  private deviceWs = inject(DeviceWebSocketService);
}
